import { useAccount } from "wagmi";
import { useEffect } from "react";
import { useAuthWallets } from "./useAuthWallets";
import { useSetActiveWallet } from "@privy-io/wagmi";

export const useAccountPrivyWallet = () => {
    const account = useAccount()

    const {
        ownershipPrivyWallet,
        ownershipWallet,
    } = useAuthWallets();
    const isPrivyActiveWagmiWallet = ownershipWallet?.address === account.address
    const { setActiveWallet } = useSetActiveWallet()

    const changeAccountActiveWallet = () => {
        if (!isPrivyActiveWagmiWallet && ownershipPrivyWallet) {
            setActiveWallet(ownershipPrivyWallet)
        }
    }

    return { isPrivyActiveWagmiWallet, changeAccountActiveWallet };
};
